import * as React from "react";
import Button from "react-bootstrap/Button";
import "./routes.css";

import Chakra from "../aMomentForYourselfArchive/09-26-2016-working-with-1st-chakra.jpg";
import ChakraBasics from "../aMomentForYourselfArchive/09-19-2016-1st-chakra-basics.jpg";
import Maintenance from "../aMomentForYourselfArchive/09-12-2016-maintenance.jpg";
import JamesBroughton from "../aMomentForYourselfArchive/09-05-2016-poem-james-broughton.jpg";
import Moment from "../aMomentForYourselfArchive/08-29-216-a-moment.jpg";
import LifeFlies from "../aMomentForYourselfArchive/08-22-2016-life-flies-by.jpg";
import Empowerment from "../aMomentForYourselfArchive/08-08-2016-empowerment.jpg";
import StandingUpStraight from "../aMomentForYourselfArchive/08-01-2016-standing-up-straight.jpg";
import AngelKiss from "../aMomentForYourselfArchive/08-2016-angel-kiss.jpg";
import NonMovingMeditation from "../aMomentForYourselfArchive/07-25-2016-non-moving-meditation.jpg";
import MeditationTips from "../aMomentForYourselfArchive/07-11-2016-more-tips-on-meditation.jpg";
import MeditationSleep from "../aMomentForYourselfArchive/07-04-2016-15-min-meditation-one-hour-sleep.jpg";
import CarpalTunnel from "../aMomentForYourselfArchive/06-2016-what-i-miss-carpal-tunnel.jpg";
import SomaticDharma from "../aMomentForYourselfArchive/11-2015-common-ground-intestines-somatic-dharma.jpg";
import BeautyMistake from "../aMomentForYourselfArchive/10-2015-beauty-mistake-foundations-consciousness.jpg";
import DarknessIntoLight from "../aMomentForYourselfArchive/09-2015-darkness-into-light-wanting-strong-shoulders.jpg";
import WalkingMeditation from "../aMomentForYourselfArchive/07-18-2015-walking-meditation.jpg";
import CalmNervousSystem from "../aMomentForYourselfArchive/07-2015-calm-nervous-system.jpg";
import Perfectionism from "../aMomentForYourselfArchive/04-2015-perfectionism-pelvic-floor.jpg";
import MuscleSpasms from "../aMomentForYourselfArchive/03-2015-sleeping-peeing-muscle-spasms.jpg";
import SleepBetter from "../aMomentForYourselfArchive/02-2015-sleep-bettter.jpg";
import BrainGym from "../aMomentForYourselfArchive/12-2014-brain-gym-calm-nervous-system.jpg";
import VisceralNervousSystem from "../aMomentForYourselfArchive/11-2014-visceral-calm-nervous-system.jpg";
import KumNyeYoga from "../aMomentForYourselfArchive/09-2014-calming-breath-from-kum-nye-yoga.jpg";

// Newest first within each year. Each entry opens the newsletter image.
const archive = [
  {
    year: "2016",
    items: [
      { date: "Sep 26", title: "Working with the 1st Chakra", img: Chakra },
      { date: "Sep 19", title: "1st Chakra Basics", img: ChakraBasics },
      { date: "Sep 12", title: "Maintenance", img: Maintenance },
      { date: "Sep 5", title: "A Poem by James Broughton", img: JamesBroughton },
      { date: "Aug 29", title: "A Moment", img: Moment },
      { date: "Aug 22", title: "Life Flies By", img: LifeFlies },
      { date: "Aug 8", title: "Empowerment", img: Empowerment },
      { date: "Aug 1", title: "Standing Up Straight", img: StandingUpStraight },
      { date: "Aug", title: "Angel Kiss", img: AngelKiss },
      { date: "Jul 25", title: "Non-Moving Meditation", img: NonMovingMeditation },
      { date: "Jul 11", title: "More Tips on Meditation", img: MeditationTips },
      {
        date: "Jul 4",
        title: "15 Minute Meditation, One Hour of Sleep",
        img: MeditationSleep,
      },
      { date: "Jun", title: "What I Miss: Carpal Tunnel", img: CarpalTunnel },
    ],
  },
  {
    year: "2015",
    items: [
      {
        date: "Nov",
        title: "Common Ground: Intestines and Somatic Dharma",
        img: SomaticDharma,
      },
      {
        date: "Oct",
        title: "Beauty, Mistakes and the Foundations of Consciousness",
        img: BeautyMistake,
      },
      {
        date: "Sep",
        title: "Darkness into Light: Wanting Strong Shoulders",
        img: DarknessIntoLight,
      },
      { date: "Jul 18", title: "Walking Meditation", img: WalkingMeditation },
      { date: "Jul", title: "Calm Nervous System", img: CalmNervousSystem },
      {
        date: "Apr",
        title: "Perfectionism and the Pelvic Floor",
        img: Perfectionism,
      },
      {
        date: "Mar",
        title: "Sleeping, Peeing and Muscle Spasms",
        img: MuscleSpasms,
      },
      { date: "Feb", title: "Sleep Better", img: SleepBetter },
    ],
  },
  {
    year: "2014",
    items: [
      {
        date: "Dec",
        title: "Brain Gym for a Calm Nervous System",
        img: BrainGym,
      },
      {
        date: "Nov",
        title: "Visceral Work for a Calm Nervous System",
        img: VisceralNervousSystem,
      },
      {
        date: "Sep",
        title: "Calming Breath from Kum Nye Yoga",
        img: KumNyeYoga,
      },
    ],
  },
];

function AMomentForYourself() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">A Moment For Yourself</h2>

          <p className="pageLead">
            Ann&rsquo;s short notes on self care, meditation, and feeling
            better in your body. Each one takes only a moment to read.
          </p>

          <div className="missionQuote">
            <strong>Want the series delivered?</strong> Sign up to receive our
            very popular &ldquo;A Moment for Yourself&rdquo; Chakra Series
            <div style={{ marginTop: "0.75rem" }}>
              <a
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                <Button size="sm">Get the Chakra Series ››</Button>
              </a>
            </div>
          </div>

          <h3 className="sectionTitle">Archives</h3>
          <p>
            Click any title to open that edition in a new tab. Newest first.
          </p>

          {archive.map((group) => (
            <React.Fragment key={group.year}>
              <h4 className="subTitle">{group.year}</h4>
              <ul className="archiveList">
                {group.items.map((item) => (
                  <li key={item.title}>
                    <span className="archiveDate">{item.date}</span>
                    <a href={item.img} target="_blank" rel="noreferrer">
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            </React.Fragment>
          ))}

          <div className="contactBox">
            <h4 className="subTitle" style={{ marginTop: 0 }}>
              Share Your Thoughts
            </h4>
            <p style={{ marginBottom: 0 }}>
              We&rsquo;re collecting testimonials to post on the website.
              Please send them to{" "}
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                bodymindspiritanatomy@gmail.com
              </a>
              .
            </p>
          </div>

          <p className="archiveFootnote">
            Ann Watkins is owner of New Harmony Therapeutic Massage and Somatic
            Bodywork. She has been in private practice since 1988 and has
            studied numerous forms of bodywork with her primary focus being
            postural correction and chronic pain. She also holds a Masters in
            Dance Movement Therapy. Copyright Jan. 2012.
          </p>
        </div>
      </div>
    </div>
  );
}
export default AMomentForYourself;
